import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PartyType } from '../../../../interfaces/myData.interface';

interface Props {
  title?: string;
  party?: PartyType;
}

export const GsisDocPartyCard = ({ title, party }: Props) => {
  const { t } = useTranslation();
  const { vatNumber, name, address, country, branch, documentIdNo, supplyAccountNo, countryDocumentId } = party || {};
  const displayVatNumber = useMemo(
    () => (vatNumber && /^\d{8}$/.test(vatNumber) ? `0${vatNumber}` : vatNumber),
    [vatNumber],
  );

  if (!party) return null;

  return (
    <div className="simpleBorder p-12 width-100">
      {title && <div className="boldText5 m-b-8">{title}</div>}

      <div className="flex-start-center-row-nowrap m-b-6">
        <div className="boldText4 p-r-6">{t('DELIVERY.VAT_NUMBER')}:</div>
        <div className="normalText4">{displayVatNumber || '-'}</div>
      </div>

      <div className="flex-start-center-row-nowrap m-b-6">
        <div className="boldText4 p-r-6">{t('DELIVERY.NAME')}:</div>
        <div className="normalText4 truncate-2lines">{name || '-'}</div>
      </div>

      {address && (
        <div className="flex-start-center-row-wrap m-b-6">
          <div className="boldText4 p-r-6">{t('DELIVERY.ADDRESS')}:</div>
          <div className="normalText4">
            {address.street || ''} {address.number || ''}
          </div>
          <div className="normalText4 p-l-4">
            {address.postalCode || ''} {address.city || ''}
          </div>
        </div>
      )}

      {branch != null && branch > 0 && (
        <div className="flex-start-center-row-nowrap m-b-6">
          <div className="boldText4 p-r-6">{t('DELIVERY.BRANCH')}:</div>
          <div className="normalText4">{branch}</div>
        </div>
      )}

      {documentIdNo && (
        <div className="flex-start-center-row-nowrap m-b-6">
          <div className="boldText4 p-r-6">{t('DELIVERY.DOCUMENT_ID')}:</div>
          <div className="normalText4">{documentIdNo}</div>
        </div>
      )}

      {supplyAccountNo && (
        <div className="flex-start-center-row-nowrap m-b-6">
          <div className="boldText4 p-r-6">{t('DELIVERY.SUPPLY_ACCOUNT_NO')}:</div>
          <div className="normalText4">{supplyAccountNo}</div>
        </div>
      )}

      {country && (
        <div className="flex-start-center-row-nowrap m-b-6">
          <div className="boldText4 padding-r-6">{t('DELIVERY.COUNTRY')}:</div>
          <div className="normalText4">{country}</div>
        </div>
      )}

      {countryDocumentId && (
        <div className="flex-start-center-row-nowrap">
          <div className="boldText4 p-r-6">{t('DELIVERY.COUNTRY_DOCUMENT_ID')}:</div>
          <div className="normalText4">{countryDocumentId}</div>
        </div>
      )}
    </div>
  );
};
